import { Id, Json, JsonEntity } from '@homeleite/arch';
import { City } from '../cities';

export class Address implements JsonEntity {
  constructor(
    public id = Id.gen(),
    public street = '',
    public number = '',
    public zipcode = '',
    public district = '',
    public city: City = null
  ) {}

  toJson() {
    return Json.to.simple(this, {
      city: this.city?.toJson(),
    });
  }

  static fromJson(json: any) {
    return Json.from.simple(json, Address, {
      city: City.fromJson(json?.city),
    });
  }
}
